import { AUTH_SUCCESS, AUTH_FAILED, AUTH_PASSED, CLEAN_ERROR } from './mutations-types'

export default {
  [AUTH_SUCCESS] (state, params) {
    state.isLoggedIn = true
    state.userName = params.user
    state.token = params.token
    state.error = ''
  },
  [AUTH_PASSED] (state, params) {
    state.isLoggedIn = true
    state.userName = params.user
    state.token = params.token
  },
  [AUTH_FAILED] (state, error) {
    state.isLoggedIn = false
    state.error = error
    state.userName = ''
    state.token = ''
  },
  [CLEAN_ERROR] (state) {
    state.error = ''
  }
}
